// App.jsx
import React, { useEffect, useState } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaDiscord,
  FaLinkedinIn,
  FaTelegramPlane,
} from "react-icons/fa";
import "./footer.css";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assests/images/horizontal_without_taglinel.png";
import whatsup from "../../assests/whatsapp.png";
import twitter from "../../assests/twitter.png";
import mailbox from "../../assests/character-illustration-people-with-internet-message-icons.png";
import QRCode from "react-qr-code";
import { useLocation } from "react-router-dom";
import blogImage from "../../assests/blogVector.png";
function GalaxyBackground() {
  const [stars, setStars] = useState([]);
  const [status, setStatus] = useState("");
  const [formData, setFormData] = useState({
    email: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const validate = () => {
    const errors = {};
    if (!formData.email || !formData.email.includes("@")) {
      errors.email = "Valid email required";
    }
    return errors;
  };

  const phoneno = "919343389975";
  const mess = "Hi I am  ";
  const wling = `https://wa.me/${phoneno}?text=${encodeURIComponent(mess)}`;
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        const payload = {
          ...formData,
        };

        const response = await fetch(
          "https://www.tekitsolution.com/email_apis.php?action=contact_footer",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(payload).toString(),
          }
        );

        const result = await response.json();
        alert("Form submitted successfully!");
        setFormData({
          email: "",
        });
        setMessage("Message sent successfully!");
        setErrors({});
        setStatus("Thanks for subscribing!");
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong. Please try again.");
      }
    } else {
      setErrors(validationErrors);
      setStatus("Please enter a valid email");
    }
  };
  // useEffect(() => {
  //     const newStars = Array.from({ length: 8 }).map((_, i) => ({
  //         id: i,
  //         left: Math.random() * 40,  // more horizontal spread
  //         delay: Math.random() * 5,
  //         duration: 5 + Math.random() * 3,
  //         top: Math.random() * 20,   // more vertical spread
  //     }));
  //     setStars(newStars);
  // }, []);
  useEffect(() => {
    const newStars = Array.from({ length: 4 }).map((_, i) => ({
      id: i,
      left: Math.random() * 40,
      delay: Math.random() * 10,
      duration: 8 + Math.random() * 10,
      top: Math.random() * 20,
    }));
    setStars(newStars);
  }, []);
  // Animation presets
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const slideLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const slideRight = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };
  const location = useLocation();
  const path = location.pathname;

  return (
    <>
      <div
        className={`flex flex-col lg:flex-row gap-6 px-4 lg:px-8 pb-2 ${
          path === "/contact-us"
            ? "bg-[#09588D]"
            : path === "/about-us" || path === "/services"
            ? "bg-[#f4f5f6] "
            : ""
        }`}
      >
        {/* Subscription Section */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={slideLeft}
          className=" text-white pb-4 bg-white rounded-2xl w-full shadow-[0_10px_40px_rgba(0,0,0,0.15)] flex flex-col lg:flex-row gap-6 "
        >
          {/* Image */}
          <motion.div
            variants={fadeInUp}
            className="w-[30%] lg:w-[50%] flex items-center justify-center"
          >
            <img
              src={mailbox}
              alt="Subscribe"
              className="w-full h-auto object-cover rounded-md"
            />
          </motion.div>

          {/* Text + Input */}
          <motion.div
            variants={fadeInUp}
            className="w-full lg:w-[50%] flex flex-col justify-center mt-3 mr-4"
          >
            <p
              className="text-2xl lg:text-3xl font-semibold font-recoleta text-start lg:text-left mt-4 
             text-black"
            >
              Subscribe to the TekBuzz{" "}
              <span className="text-sm text-gray-600">(Newsletter)</span>
              <br />
              <span className="text-base font-normal text-gray-700 leading-relaxed block mt-2">
                Stay ahead with the latest tech trends, updates &
                insights—straight to your inbox.
              </span>
            </p>

            <div className="mt-6 flex flex-col sm:flex-row items-center sm:items-stretch gap-4">
              <div className="flex items-center w-full  border border-gray-700 bg-[#111] rounded-md lg:h-[52px]">
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  placeholder="name@email.com"
                  className="bg-transparent text-white placeholder-gray-400 p-3 text-base sm:text-sm w-full outline-none"
                />
              </div>
              <button
                onClick={handleSubmit}
                className="bg-[#2B80B9] text-white px-6 py-3  lg:py-0 rounded-md hover:bg-gray-700 transition text-base sm:text-sm"
              >
                ⮐ Subscribe
              </button>
            </div>

            {status && <p className="text-sm text-red-500 mt-2">{status}</p>}
          </motion.div>
        </motion.div>

      </div>

      <div className="App relative min-h-screen overflow-hidden bg-black text-white">
        {/* Small moving stars background */}
        <div className="stars"></div>
        {/* Three big shooting stars launching together from top-left */}
        <div className="shooting-wrapper">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="shooting-star"
              style={{
                // all three start off-screen at top-left
                top: `-20px`,
                left: `-20px`,
                // stagger their delays slightly so they overlap
                animationDelay: `${i * 0.5}s`,
              }}
            />
          ))}
        </div>
        <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center space-y-6 relative overflow-hidden">
          {/* Shooting Stars */}
          <div className="flex flex-col items-center">
            <img src={logo} className="w-40 sm:w-52 lg:w-44 2xl:mt-6 lg:mt-10 mt-10" />
            <h2 className="lg:text-[20px] text-base sm:text-lg lg:text-base text-center">
              Tech Innovation and Skilled Talent, Unified
            </h2>
          </div>
          {stars.map((star) => (
            <div
              key={star.id}
              className="shooting-star absolute"
              style={{
                top: `${star.top}%`,
                left: `${star.left}%`,
                animationDelay: `${star.delay}s`,
                animationDuration: `${star.duration}s`,
              }}
            >
              <div className="star-glow" />
            </div>
          ))}

          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-[26px] pt-2 font-bold text-white">
              Reach Out, We’re Here ✨{" "}
            </h2>
            <div className="flex flex-col sm:flex-row pt-4 gap-4 justify-center lg:mb-0 mb-20 z-10">
              <a
                target="_blank"
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=hr@tekitsolution.com`}
                className="px-6 py-3 text-base sm:text-lg bg-gray-900 rounded-xl hover:bg-gray-700 transition text-center w-full sm:w-auto"
              >
                Email Us
              </a>
              <a
                href="tel:+919343389975" // replace with your actual phone number
                className="px-6 py-3 text-base sm:text-lg bg-gray-900 rounded-xl hover:bg-gray-700 transition text-center w-full sm:w-auto"
              >
                Call Us
              </a>
            </div>
          </div>
          <div className="flex z-10 pt-4">
            <Link
              target="_blank"
              to="https://www.facebook.com/TekITSoftwares?mibextid=wwXIfr&rdid=6NSH1No8kSI4k0Hn&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F16Mgg7LndZ%2F%3Fmibextid%3DwwXIfr#"
              className="bg-white hover:ring-2 hover:ring-blue-400 rotate-[-4deg] left-44 top-0 z-30 w-12 h-12 sm:w-14 sm:h-14 lg:w-10 lg:h-10 flex justify-center p-2 rounded-lg "
            >
              <img
                src="https://framerusercontent.com/images/WsOrnTcVBswZzpfGscwQvXOqA.svg"
                className="transition-transform duration-300 ease-in-out hover:scale-125   rounded-full"
                alt="facebook"
              />
            </Link>

            <Link
              target="_blank"
              to="https://x.com/tekitsoftwares"
              className="bg-white w-12 h-12 sm:w-14 sm:h-14 lg:w-10 lg:h-10 rotate-[4deg] flex justify-center p-2 hover:ring-2 hover:ring-blue-400 rounded-lg "
            >
              <img
                className="transition-transform duration-300 ease-in-out hover:scale-125   rounded-full"
                src={twitter}
                alt="tek_it"
              />
            </Link>
            <Link
              target="_blank"
              to="https://www.instagram.com/tekitsoftwares/"
              className="bg-white w-12 h-12 sm:w-14 sm:h-14 lg:w-10 lg:h-10 rotate-[-4deg] flex justify-center p-2 hover:ring-2 hover:ring-pink-600 rounded-lg "
            >
              <img
                className="transition-transform duration-300 ease-in-out hover:scale-125   rounded-full"
                src="https://framerusercontent.com/images/yG9VRBszJaaxNfceWbu097Z8hA.svg"
                alt="instagram"
              />
            </Link>
            <Link
              target="_blank"
              to="https://www.youtube.com/@TekITSoftwares "
              className="rotate-[4deg] bg-white w-12 h-12 sm:w-14 sm:h-14 lg:w-10 lg:h-10 flex justify-center p-2 hover:ring-2 hover:ring-red-600 rounded-lg "
            >
              <img
                className="transition-transform duration-300 ease-in-out hover:scale-125   rounded-full"
                src="https://framerusercontent.com/images/BgC7bhN4HhHtKaurUNRrl9WYc.svg"
                alt="youtube"
              />
            </Link>
            {/* <div className='rotate-[-4deg]  bg-white w-12 h-12 sm:w-14 sm:h-14 lg:w-10 lg:h-10 flex justify-center p-2 hover:ring-2 hover:ring-blue-600 rounded-lg '>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/zI0AyM8s3ALn2MBQdYz7GzIcJmo.svg' />
          </div> */}
            <Link
              target="_blank"
              to="https://www.linkedin.com/company/tekit-softwares"
              className="rotate-[-4deg] bg-white w-12 h-12 sm:w-14 sm:h-14 lg:w-10 lg:h-10 flex justify-center p-2 hover:ring-2 hover:ring-blue-800 rounded-lg "
            >
              <img
                className="transition-transform duration-300 ease-in-out hover:scale-125   rounded-full"
                src="https://framerusercontent.com/images/HII5BEEfK2Gl8LGtH6jbbtVFd4.svg"
                alt="linkedin"
              />
            </Link>
            {/* <div className='rotate-[4deg] bg-white w-12 h-12 sm:w-14 sm:h-14 lg:w-10 lg:h-10 flex justify-center p-2 hover:ring-2 hover:ring-blue-400 rounded-lg h-10'>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/AofZHvJcQEhcfWd0lOzSsNDzM.svg' />
          </div> */}
          </div>

          {/* <p className="lg:text-[18px] text-[50px] font-medium z-10">Click to go to the social media handles</p> */}
          {/* href={`https://mail.google.com/mail/?view=cm&fs=1&to=${service.email}`} */}

          <footer className=" text-sm pt-6 font-recoleta">
          <div className="max-w-screen-xl w-[90%] mx-auto px-4 
     grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 
     pb-6 border-b border-gray-300 mt-10 text-white">

  {/* Column 1 — Sales + HR */}
  <div>
    <h3 className="font-bold text-2xl sm:text-3xl lg:text-xl lg:text-xl mt-12 lg:mt-0 mb-2 text-center lg:text-left">
      Sales
    </h3>
    <p className="text-base sm:text-lg lg:text-base lg:text-base leading-relaxed mt-16 lg:mt-0 text-center lg:text-left">
      <span className="font-semibold">Email:</span> sales@tekitsolution.com<br />
      <span className="font-semibold">Phone:</span> +91 - 9343389975
    </p>

    <h3 className="font-bold text-2xl sm:text-3xl lg:text-xl lg:text-xl mt-20 lg:mt-3 mb-1 text-center lg:text-left">
      HR Process
    </h3>
    <p className="text-base sm:text-lg lg:text-base lg:text-base leading-relaxed mt-12 lg:mt-0 text-center lg:text-left">
      <span className="font-semibold">Email:</span> hr@tekitsolution.com<br />
      <span className="font-semibold">Phone:</span> +91 - 9685308585
    </p>
  </div>

  {/* Column 2 — Explore More (center aligned) */}
  <div className="flex flex-col items-center justify-center">
    <h3 className="font-bold text-2xl sm:text-3xl lg:text-xl lg:text-xl mb-3 text-center">
      Explore More
    </h3>

    <ul className="space-y-3 text-[20px] lg:text-base text-center">
      <li><a href="/careers" className="hover:text-blue-400 underline">Career Opportunities</a></li>
      <li><a href="/staffing" className="hover:text-blue-400 underline">Hire Developer</a></li>
      <li><a href="/about-tekit" className="hover:text-blue-400 underline">About TekIT</a></li>
      <li><a href="/services" className="hover:text-blue-400 underline">Services We Offer</a></li>
    </ul>
  </div>

  {/* Column 3 — QR Code (right aligned) */}
  <div className="flex justify-center lg:justify-end items-center">
    <a
      href="https://wa.me/919343389975?text=Hi%20I%20visited%20your%20website"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={whatsup}
        alt="WhatsApp QR"
        className="w-60 lg:w-40 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
      />
    </a>
  </div>

</div>


            {/* Bottom copyright */}
            <div className="text-center py-4 lg:text-[18px] text-[44px] text-white mt-4 ">
              © 2025 TekIT. All Rights Reserved
            </div>
          </footer>
        </div>

        {/* Your page content */}
        {/* <div className="relative z-10 flex flex-col items-center pt-10"> */}
        {/* …nav, inputs, buttons, etc.… */}
        {/* </div> */}
      </div>
    </>
  );
}

export default GalaxyBackground;
